import { z } from "zod";

const ApplicationType = {
  FAST_APPLICATION: "FAST_APPLICATION",
  EXPORT_APPLICATION: "EXPORT_APPLICATION",
  FAST_APPLICATION_EMAIL: "FAST_APPLICATION_EMAIL",
  EXTERNAL: "EXTERNAL",
  NONE: "NONE",
};

const INTERNAL_APPLICATION_TYPES = [
  ApplicationType.FAST_APPLICATION,
  ApplicationType.EXPORT_APPLICATION,
  ApplicationType.FAST_APPLICATION_EMAIL,
];

export const applyButtonComputed = {
  computed: {
    applicationUrl() {
      const jobData = this.jobData;
      const applicationType = jobData && jobData.application_type;

      if (INTERNAL_APPLICATION_TYPES.includes(applicationType)) {
        return "#application-form";
      }

      if (applicationType === ApplicationType.EXTERNAL) {
        return jobData && jobData.application_url;
      }

      return null;
    },
    shouldShowApplyButton() {
      if (!this.module.config.applyButton) {
        return false;
      }

      const jobData = this.jobData;
      const applicationType = jobData && jobData.application_type;

      if (INTERNAL_APPLICATION_TYPES.includes(applicationType)) {
        return true;
      }

      if (applicationType === ApplicationType.EXTERNAL) {
        const applicationUrl = jobData && jobData.application_url;
        if (!applicationUrl) {
          return false;
        }

        const urlSchema = z.url();
        const result = urlSchema.safeParse(applicationUrl);
        return result.success;
      }

      if (applicationType === ApplicationType.NONE) {
        return false;
      }

      return true;
    },
  },
};
